/** Customer-facing /customs dashboard (sidebar + route). Set false to hide from customers. */
export const CUSTOMS_PAGE_ENABLED = true;

/** Dexwork / Lean Customs web app base URL (Step 1 migration: app.dex.work). */
export const LEANCUSTOMS_APP_BASE_URL = "https://app.dex.work";

export const LEANCUSTOMS_ORDER_BASE = `${LEANCUSTOMS_APP_BASE_URL}/orders`;
export const LEANCUSTOMS_DECLARATION_BASE = `${LEANCUSTOMS_APP_BASE_URL}/declarations`;
export const LEANCUSTOMS_ORGANIZATION_BASE = `${LEANCUSTOMS_APP_BASE_URL}/organizations`;
export const LEANCUSTOMS_CONTRACT_BASE = `${LEANCUSTOMS_APP_BASE_URL}/contracts`;

/** Dexwork customs representative (agent) org — maps to declaration `representative_id`. */
export const LEANCUSTOMS_AGENT_ID = "dc9cc16e-8ba5-411d-90c0-bdcc7e98dfd3";

/** E-Freight org: order `client_id`, declaration `forwarder_id`. */
export const LEANCUSTOMS_EFREIGHT_ORG_ID = "701d441f-ac96-40e9-9998-cbfe58df1bdf";

/** Indirect representation (E-Freight acting for declarant). See Dexwork representative_status. */
export const LEANCUSTOMS_REPRESENTATIVE_STATUS = "3";
